/**
 * Class for handling the clear filter button in a listing module
 */
class ListingModule {
	/**
	 * Setup and check if elements exist
	 *
	 * @return {void}
	 */
	static setup() {
		const moduleEls = [...document.querySelectorAll('.module-listing')];

		if (moduleEls.length > 0) {
			for (const moduleEl of moduleEls) {
				const listingModuleClass = new ListingModule(moduleEl);
				listingModuleClass.init();
			}
		}
	}
	/**
	 * This runs on load
	 *
	 * @param {HTMLElement} el
	 */
	constructor(el) {
		this.module = el;
		this.clearFilter = this.module.querySelector('.listing-clear-filter');
		this.searchInput = this.module.querySelector('.search-input-wrapper input');
	}

	/**
	 * Initialize function
	 *
	 * @return {void}
	 */
	init() {
		if (this.clearFilter) {
			this.clearFilter.classList.add('disabled');
		}
		this.addEventlisteners();
	}

	/**
	 * Handle eventlisteners
	 *
	 * @return {void}
	 */
	addEventlisteners() {
		if (this.clearFilter) {
			this.module.addEventListener('module-listing:taxonomy-filter', this.handleDisabled.bind(this));
			this.module.addEventListener('module-listing:search', this.removeDisabledBySearch.bind(this));
			this.module.addEventListener('module-listing:filters-reset', this.addDisabled.bind(this));
		}
	}

	/**
	 * Handle disable button state if any filter is applied
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	handleDisabled(e) {
		// All filter dropdowns
		const filterEls = this.module.querySelectorAll('.listing-filter-taxonomy');
		// All filter options which is "all" and chosen
		const filterAllEls = this.module.querySelectorAll(
			'.listing-filter-taxonomy .module-listing-filter-all.current-listing-filter',
		);

		// If the same number of "all" options are chosen as there are dropdowns, filter should be empty.
		if (filterEls.length === filterAllEls.length && this.searchInput.value.length <= 0) {
			if (!this.clearFilter.classList.contains('disabled')) {
				this.clearFilter.classList.add('disabled');
			}

			return;
		}

		// Remove disabled state if a filter is chosen
		if (this.clearFilter.classList.contains('disabled')) {
			this.clearFilter.classList.remove('disabled');
		}
	}

	/**
	 * Remove disabled if any filtersearch query is applied
	 *
	 * @return {void}
	 */
	removeDisabledBySearch() {
		if (this.searchInput.value.length <= 0) {
			if (!this.clearFilter.classList.contains('disabled')) {
				this.clearFilter.classList.add('disabled');
			}

			this.handleDisabled();
			return;
		}

		if (this.clearFilter.classList.contains('disabled')) {
			this.clearFilter.classList.remove('disabled');
		}
	}

	/**
	 * Add disabled if fitler is cleared
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	addDisabled(e) {
		if (!this.clearFilter.classList.contains('disabled')) {
			this.clearFilter.classList.add('disabled');
		}
	}
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
	ListingModule.setup();
} else {
	document.addEventListener('DOMContentLoaded', ListingModule.setup);
}
